<template lang="pug">
.section
  .section-header
    template(v-if="!isDetail")
      h1 {{ $t("ui.promotion_withdrawal_summary") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
      h1 {{ $t("ui.promotion_withdrawal_summary_detail") }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0)" @click="redirect()") {{ $t("ui.promotion_withdrawal_summary") }}
        .breadcrumb-item.active
          span {{ $t('ui.promotion_withdrawal_summary_detail') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          template(v-if="!isDetail")
            .card-header
              .row.w-100              
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getList(true)" size="sm")
                .form-group.col-md-12.col-lg-6.col-xl-9.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getList(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="summaryList.length > 0" mode="PromotionWithdrawalSummary" tbl="tblSummary" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="summaryListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="PromotionWithdrawalSummary" tbl="tblSummaryFull" :date="dateRange" btnTxt="export_all" type="0" :loading2="loading2")
                  promotionWithdrawalSummaryExport(v-if="summaryList.length > 0" :tbl="summaryList" tblId="tblSummary" :totalTbl="grandTotalList")
                  promotionWithdrawalSummaryExportFull(v-if="summaryListFull.length > 0 && $helpers.showExportAll(dateRange) == true" :tbl="summaryListFull" tblId="tblSummaryFull" :totalTbl="grandTotalListFull")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                      thead.thead-light
                        tr
                          th.text-center(width="3%")
                            span #
                          th(width="10%" v-if="!isOperator")
                            span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                          th(width="10%")
                            span(:title="$t('ui.promo_id')") {{ $t('ui.promo_id') }}
                          th(width="35%")
                            span(:title="$t('ui.promo_name')") {{ $t('ui.promo_name') }}
                          th.text-right(width="20%")
                            span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                          th.text-right(width="15%")
                            span(:title="$t('ui.withdrawal_count')") {{ $t("ui.withdrawal_count") }}
                          th.text-right(width="15%")
                            span(:title="$t('ui.unique_player')") {{ $t("ui.unique_player") }}
                      tbody.clusterize-content
                        tr(v-if="summaryList.length == 0")
                          td(:colspan="!isOperator ? '7' : '6'").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in summaryList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td(v-if="!isOperator")
                            span(:title="item.operator_id") {{ item.operator_id }}
                          td
                            span(:title="item.promotion_id")
                              b-link.clickable(href="javascript:void(0);" @click="drillIn(item)") {{ item.promotion_id }}
                          td
                            span(:title="item.promotion_name") {{ item.promotion_name }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.withdrawal_amount, 'currency')" :class="$helpers.fontClassName(item.withdrawal_amount)") {{ $n(item.withdrawal_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
                          td.text-right
                            span(:title="$n(item.unique_player, 'integer')") {{ $n(item.unique_player, 'integer') }}
                        tr(v-if="showTotal")
                          td.text-right(:colspan="!isOperator ? '4': '3'")
                            span.d-block {{ $t("ui.sub_total") }}
                            span {{ $t("ui.grand_total") }}
                          td.text-right
                            span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWithdrawalAmount)" :title="$n(subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount, 'currency') }}
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalAmount)" :title="$n(grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount, 'currency') }}
                          td.text-right
                            span.font-weight-bold.d-block(:title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
                            span.font-weight-bold(:title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
                          td.text-right
                            span.font-weight-bold.d-block(:title="$n(subTotalUniquePlayer, 'integer')") {{ $n(subTotalUniquePlayer, 'integer') }}
                            span.font-weight-bold(:title="$n(grandTotalUniquePlayer, 'integer')") {{ $n(grandTotalUniquePlayer, 'integer') }}
          template(v-else)
            .card-header
              .row.w-100
                .form-group.col-md-12.col-lg-12.col-xl-6.col-12.mb-1
                  DateRangePicker(:value="dateRange1" @update="getData1")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getListDetail(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcel(v-if="detailList.length > 0" mode="PromotionWithdrawalSummaryDetail" tbl="tblSummaryDetail" :date="dateRange1" btnTxt="export_one" type="0" :loading2="loading2").mr-2
                  jsonToExcelFull(v-if="detailListFull.length > 0 && $helpers.showExportAll(dateRange1) == true" mode="PromotionWithdrawalSummaryDetail" tbl="tblSummaryDetailFull" :date="dateRange1" btnTxt="export_all" type="0" :loading2="loading2")
                  promotionWithdrawalSummaryDetailExport(v-if="detailList.length > 0" :tbl="detailList" tblId="tblSummaryDetail" :totalTbl="grandTotalListDetail")
                  promotionWithdrawalSummaryDetailExportFull(v-if="detailListFull.length > 0 && $helpers.showExportAll(dateRange1) == true" :tbl="detailListFull" tblId="tblSummaryDetailFull" :totalTbl="grandTotalListDetailFull")
            .card-body
              .row
                .col-12.mb-1
                  h2.section-title.mt-0 {{ selectedPromoId }}
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow1"
                    :per-page="getPageSize"
                    v-model="currentPage1"
                    @input="changedPage1($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize1" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(style="width: 100%; table-layout: fixed;")
                      thead.thead-light
                        tr
                          th.text-center(width="4%")
                            span #
                          th.text-nowrap(width="16%" @click="sortOrder1('claim_date')")
                            span(:title="$t('ui.claim_date')") {{ $t('ui.claim_date') }}
                            .float-right
                              i(:class="changeSortKey1('claim_date')")
                          th.text-nowrap(width="12%" @click="sortOrder1('member_id')")
                            span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                            .float-right
                              i(:class="changeSortKey1('member_id')")
                          th.text-nowrap(width="14%")
                            span(:title="$t('ui.provider_list')") {{ $t('ui.provider_list') }}
                          th.text-nowrap(width="15%")
                            span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                          th.text-right.text-nowrap(width="13%" @click="sortOrder1('deposit_amount')")
                            span(:title="$t('ui.deposit_amount')") {{ $t("ui.deposit_amount") }}
                            .float-right
                              i(:class="changeSortKey1('deposit_amount')")
                          th.text-right.text-nowrap(width="13%" @click="sortOrder1('bonus_amount')")
                            span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                            .float-right
                              i(:class="changeSortKey1('bonus_amount')")
                          th.text-right.text-nowrap(width="13%" @click="sortOrder1('withdrawal_amount')")
                            span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                            .float-right
                              i(:class="changeSortKey1('withdrawal_amount')")
                      tbody.clusterize-content
                        tr(v-if="detailList.length == 0")
                          td(colspan="8").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in detailList")                          
                          td.text-center
                            span(:title="((currentPage1 - 1) * getPageSize + index + 1)") {{ ((currentPage1 - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.claim_date ? $moment(item.claim_date).format('YYYY-MM-DD HH:mm:ss') : ''") {{ item.claim_date ? $moment(item.claim_date).format('YYYY-MM-DD HH:mm:ss') : '' }}
                          td
                            span(:title="item.member_id || item.account_id") {{ item.member_id || item.account_id }}
                          td
                            template(v-if="item.provider_list")
                              b-badge.mr-1.mb-1(
                                v-for="(provider, i) in item.provider_list.split(',').map(p => p.trim())"
                                :key="i + '-' + provider"
                                variant="secondary"
                              )
                                | {{ provider }}
                            template(v-else)
                              b-badge {{ $t('ui.all') }}
                          td
                            span(:title="item.remark") {{ item.remark }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.deposit_amount, 'currency')" :class="$helpers.fontClassName(item.deposit_amount)") {{ $n(item.deposit_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.bonus_amount, 'currency')" :class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.withdrawal_amount, 'currency')" :class="$helpers.fontClassName(item.withdrawal_amount)") {{ $n(item.withdrawal_amount, 'currency') }}
                        tr(v-if="showTotalDetail")
                          td.text-right(colspan="5")
                            span.d-block {{ $t("ui.sub_total") }} 
                            span {{ $t("ui.grand_total") }}
                          td.text-right
                            span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalDepositAmountDetail)" :title="$n(subTotalDepositAmountDetail, 'currency')") {{ $n(subTotalDepositAmountDetail, 'currency') }}
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmountDetail)" :title="$n(grandTotalDepositAmountDetail, 'currency')") {{ $n(grandTotalDepositAmountDetail, 'currency') }}
                          td.text-right
                            span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalBonusAmountDetail)" :title="$n(subTotalBonusAmountDetail, 'currency')") {{ $n(subTotalBonusAmountDetail, 'currency') }}
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmountDetail)" :title="$n(grandTotalBonusAmountDetail, 'currency')") {{ $n(grandTotalBonusAmountDetail, 'currency') }}
                          td.text-right
                            span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWithdrawalAmountDetail)" :title="$n(subTotalWithdrawalAmountDetail, 'currency')") {{ $n(subTotalWithdrawalAmountDetail, 'currency') }}
                            span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalAmountDetail)" :title="$n(grandTotalWithdrawalAmountDetail, 'currency')") {{ $n(grandTotalWithdrawalAmountDetail, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import promotionWithdrawalSummaryExport from "@/components/report/promotionWithdrawalSummaryExportFull.vue";
import promotionWithdrawalSummaryExportFull from "@/components/report/promotionWithdrawalSummaryExportFull.vue";
import promotionWithdrawalSummaryDetailExport from "@/components/report/promotionWithdrawalSummaryDetailExportFull.vue";
import promotionWithdrawalSummaryDetailExportFull from "@/components/report/promotionWithdrawalSummaryDetailExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    jsonToExcelFull,
    promotionWithdrawalSummaryExport,
    promotionWithdrawalSummaryExportFull,
    promotionWithdrawalSummaryDetailExport,
    promotionWithdrawalSummaryDetailExportFull
  },
  data: () => ({
    loading2: false,
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    dateRange1: {
      startDate: null,
      endDate: null
    },
    currentPage: 1,
    totalRow: 0,
    currentPage1: 1,
    totalRow1: 0,
    sortKey: "operator_id",
    sortType: "desc",
    sortKey1: "action_date",
    sortType1: "desc",
    searchID: "",
    isDetail: false,
    summaryList: [],
    summaryListFull: [],
    detailList: [],
    detailListFull: [],
    selectedPromoId: null,
    selectedOperatorId: null,
    subTotalWithdrawalAmount: 0,
    subTotalWithdrawalCount: 0,
    subTotalUniquePlayer: 0,
    grandTotalWithdrawalAmount: 0,
    grandTotalWithdrawalCount: 0,
    grandTotalUniquePlayer: 0,
    subTotalDepositAmountDetail: 0,
    subTotalWithdrawalAmountDetail: 0,
    subTotalBonusAmountDetail: 0,
    grandTotalDepositAmountDetail: 0,
    grandTotalWithdrawalAmountDetail: 0,
    grandTotalBonusAmountDetail: 0,
    showTotal: false,
    showTotalDetail: false,
    grandTotalList: [],
    grandTotalListFull: [],
    grandTotalListDetail: [],
    grandTotalListDetailFull: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }
      }

      this.getList(true);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getSummaryList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    sortOrder1(key) {
      if (this.sortKey1 == key)
        this.sortType1 = this.sortType1 == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey1 = key;
        this.sortType1 = 'asc';
      }
      this.getSummaryDetailList(true);
    },
    changeSortKey1(key) {
      if (this.sortKey1 != key)
        return 'fas fa-sort';
      else if (this.sortKey1 == key && this.sortType1 == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey1 == key && this.sortType1 == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange(range) {
      var dateRange = range || this.dateRange;
      if (this.$moment(dateRange.endDate).diff(this.$moment(dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getList(isSearch) {
      if (this.checkDateRange(this.dateRange)) {
        this.getSummaryList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange) == true) {
          this.getSummaryListFull(isSearch);
        }
      } else {
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getListDetail(isSearch) {
      if (this.checkDateRange(this.dateRange1)) {
        this.getSummaryDetailList(isSearch);
        if (this.$helpers.showExportAll(this.dateRange1) == true) {
          this.getSummaryDetailListFull(isSearch);
        }
      } else {
        this.clearTotalDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getList(true);
    },
    getData1(currentValue) {
      this.dateRange1.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange1.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListDetail(true);
    },
    redirect() {
      this.isDetail = false;
      this.clearTotalDetail();
      this.getList(true);
    },
    drillIn(item) {
      this.isDetail = true;
      this.dateRange1.startDate = this.dateRange.startDate;
      this.dateRange1.endDate = this.dateRange.endDate;
      this.selectedPromoId = item.promotion_id;
      this.selectedOperatorId = item.operator_id || this.searchID;
      this.currentPage1 = 1;
      this.detailList = [];
      this.detailListFull = [];
      this.getListDetail(true);
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.searchID,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getSummaryList: function(isSearch) {
      if (this.checkDateRange(this.dateRange)) {
        this.setReportStatementParam();
        let url = config.promotionWithdrawalSummaryUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.summary.length > 0) {
                    this.showTotal = true;
                    response.data.ds.summary.forEach(value => {
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"] || 0);
                      this.subTotalWithdrawalCount = parseFloat(this.subTotalWithdrawalCount) + parseFloat(value["withdrawal_count"] || 0);
                      this.subTotalUniquePlayer = parseFloat(this.subTotalUniquePlayer) + parseFloat(value["unique_player"] || 0);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalWithdrawalCount = response.data.ds.grand_total[0]["withdrawal_count"];
                      this.grandTotalUniquePlayer = response.data.ds.grand_total[0]["unique_player"];
                    }

                    this.grandTotalList = response.data.ds.grand_total;
                    this.summaryList = response.data.ds.summary;
                    this.totalRow = this.summaryList.length > 0 ? this.summaryList[0].totalrows : 0;
                  } else {
                    this.clearTotal();
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getSummaryListFull: function() {
      if (this.checkDateRange(this.dateRange)) {
        let url = config.promotionWithdrawalSummaryUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.grandTotalListFull = response.data.ds.grand_total;
                  this.summaryListFull = response.data.ds.summary;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    toRowArray: function(rows) {
      if (!rows) return [];
      if (Array.isArray(rows)) return rows;
      if (typeof rows === 'string') {
        try {
          return this.toRowArray(JSON.parse(rows));
        } catch (e) {
          return [];
        }
      }
      if (typeof rows === 'object') return [rows];
      return [];
    },
    getDetailRows: function(data) {
      if (!data) return [];
      var ds = data.ds || {};
      var rows = ds.summarydetail || ds.summary || ds.list || ds.Table || data.dt || [];
      return this.toRowArray(rows);
    },
    getDetailGrandTotal: function(data) {
      var ds = (data && data.ds) || {};
      return this.toRowArray(ds.grand_total || ds.Table1);
    },
    getSummaryDetailList: function(isSearch) {
      if (this.checkDateRange(this.dateRange1)) {
        let url = config.promotionWithdrawalSummaryDetailUrl();

        if (isSearch) this.currentPage1 = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorId,
          promotion_id: this.selectedPromoId,
          start_date: this.dateRange1.startDate,
          end_date: this.dateRange1.endDate,
          // sort_key: this.sortKey1,
          sort_type: this.sortType1,
          page_number: this.currentPage1,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalDetail();
            this.loading = false;
            // Success
            try {
              if (response) {
                // console.log(response.data);
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  var list = this.getDetailRows(response.data);
                  var grandTotal = this.getDetailGrandTotal(response.data);
                  if(list.length > 0) {
                    this.showTotalDetail = true;

                    list.forEach(value => {
                      this.subTotalWithdrawalAmountDetail = parseFloat(this.subTotalWithdrawalAmountDetail) + parseFloat(value["withdrawal_amount"] || 0);
                      this.subTotalDepositAmountDetail = parseFloat(this.subTotalDepositAmountDetail) + parseFloat(value["deposit_amount"] || 0);
                      this.subTotalBonusAmountDetail = parseFloat(this.subTotalBonusAmountDetail) + parseFloat(value["bonus_amount"] || 0);
                    });

                    if(grandTotal.length > 0) {
                      this.grandTotalWithdrawalAmountDetail = grandTotal[0]["withdrawal_amount"];
                      this.grandTotalDepositAmountDetail = grandTotal[0]["deposit_amount"];
                      this.grandTotalBonusAmountDetail = grandTotal[0]["bonus_amount"];
                    }

                    this.grandTotalListDetail = grandTotal;
                    this.detailList = list;
                    this.totalRow1 = this.detailList.length > 0 ? this.detailList[0].totalrows : 0;
                  } else {
                    this.clearTotalDetail();
                  }
                } else {
                  this.clearTotalDetail();
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.clearTotalDetail();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getSummaryDetailListFull: function(isSearch) {
      if (this.checkDateRange(this.dateRange1)) {
        let url = config.promotionWithdrawalSummaryDetailUrl();

        if (isSearch) this.currentPage1 = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.selectedOperatorId,
          promotion_id: this.selectedPromoId,
          start_date: this.dateRange1.startDate,
          end_date: this.dateRange1.endDate,
          sort_key: this.sortKey1,
          sort_type: this.sortType1,
          page_number: this.currentPage1,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.grandTotalListDetailFull = this.getDetailGrandTotal(response.data);
                  this.detailListFull = this.getDetailRows(response.data);
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    clearTotal() {
      this.showTotal = false
      this.summaryList = []
      this.totalRow = 0
      this.subTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.subTotalUniquePlayer = 0
      this.grandTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalCount = 0
      this.grandTotalUniquePlayer = 0
    },
    clearTotalDetail() {
      this.showTotalDetail = false
      this.detailList = []
      this.totalRow1 = 0
      this.subTotalWithdrawalAmountDetail = 0
      this.subTotalDepositAmountDetail = 0
      this.subTotalBonusAmountDetail = 0
      this.grandTotalWithdrawalAmountDetail = 0
      this.grandTotalDepositAmountDetail = 0
      this.grandTotalBonusAmountDetail = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSummaryList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSummaryList();
    },
    changedPageSize1: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage1 = 1;
      this.getSummaryDetailList(true);
    },
    changedPage1: function(pageNo) {
      this.currentPage1 = pageNo;
      this.getSummaryDetailList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>
